module.exports = __webpack_public_path__ + "img/bedBlue.3bfa0f18.png";